import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Nav from '@src/routes';

import { useRememberRedirectUrl } from './hooks/useRememberRedirectUrl';

// Landing point for the Cognito SSO full-page redirect (redirectSignIn = root `/`).
// Honors the path captured before the redirect, else defaults to Submissions.
// Read-once (getRedirectUrlOnce clears the key) so a stale/looping value can't bounce.
export const RootRedirect = () => {
  const { getRedirectUrlOnce } = useRememberRedirectUrl();
  const [to] = useState(() => getRedirectUrlOnce(Nav.Submissions));

  return <Navigate to={to} replace />;
};
